import { render, staticRenderFns } from "./prview.vue?vue&type=template&id=8e4e126c&scoped=true&"
import script from "./prview.vue?vue&type=script&lang=js&"
export * from "./prview.vue?vue&type=script&lang=js&"
import style0 from "./prview.vue?vue&type=style&index=0&id=8e4e126c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e126c",
  null
  
)

export default component.exports